import { UserProfile } from '@/models/user-profile';
import * as fb from '@/firebase';
import * as _ from 'lodash';
import firebase from 'firebase/app';
import { UserProfileUtil } from '@/model-utils/user-profile-util';

export class UserFollowActions {
  public static async getFollowersForUser(
    userId: string
  ): Promise<UserProfile[]> {
    const snapshot = await UserFollowActions.getReverseCollection(userId).get();
    const users = snapshot.docs.map((d) => {
      return {
        id: d.id,
        ts: d.data().ts
      };
    });

    const orderedUsers = _.orderBy(users, 'ts', 'desc');
    const userIds = _.map(orderedUsers, 'id');
    return UserProfileUtil.hydrateUsers(userIds);
  }

  public static async getFollowsForUser(
    userId: string
  ): Promise<UserProfile[]> {
    const snapshot = await UserFollowActions.getCollection(userId).get();
    const userIds = snapshot.docs.map((d) => d.id);
    return UserProfileUtil.hydrateUsers(userIds);
  }

  public static watchFollowedUserIdsForUser(
    userId: string,
    callback: (l: string[]) => void
  ): void {
    this.getCollection(userId).onSnapshot(
      (snapshot: firebase.firestore.QuerySnapshot) => {
        callback(snapshot.docs.map((d) => d.id));
      },
      (error) => {console.error('error in user follow watch', error);}
    );
  }

  public static isUserFollowing({
    srcUserId,
    destUserId
  }: {
    srcUserId: string;
    destUserId: string;
  }): Promise<boolean> {
    return UserFollowActions.getRef({ srcUserId, destUserId })
      .get()
      .then((docSnapshot) => {
        return docSnapshot.exists;
      });
  }

  public static getCollection(
    userId: string
  ): firebase.firestore.CollectionReference {
    return fb.usersCollection.doc(userId).collection('following');
  }

  public static getRef({
    srcUserId,
    destUserId
  }: {
    srcUserId: string;
    destUserId: string;
  }): firebase.firestore.DocumentReference {
    return UserFollowActions.getCollection(srcUserId).doc(destUserId);
  }

  public static getReverseCollection(
    userId: string
  ): firebase.firestore.CollectionReference {
    return fb.usersCollection.doc(userId).collection('followers');
  }

  public static getReverseRef({
    srcUserId,
    destUserId
  }: {
    srcUserId: string;
    destUserId: string;
  }): firebase.firestore.DocumentReference {
    return UserFollowActions.getReverseCollection(destUserId).doc(srcUserId);
  }

  public static async followUser({
    srcUserId,
    destUserId
  }: {
    srcUserId: string;
    destUserId: string;
  }): Promise<any> {
    console.log('https call');
    const followUser = firebase.functions().httpsCallable('app/followUser');
    return followUser({srcUserId, destUserId}).then((result) => {
      return result.data;
    });
  }

  public static unfollowUser({
    srcUserId,
    destUserId
  }: {
    srcUserId: string;
    destUserId: string;
  }): Promise<any> {
    console.log('https call');
    const unfollowUser = firebase.functions().httpsCallable('app/unfollowUser');
    return unfollowUser({srcUserId, destUserId}).then((result) => {
      return result.data;
    });
  }
}
